import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import {
  TIP_PION_TYPES,
  TIP_PION_TYPES_NAMES,
} from '../../../../../../constants/tasks';

import './index.scss';

const MutateTipPionActionType = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <select
      {...props}
      {...field}
      className={classNames(
        'mutate-tip-pion-action-type',
        { 'mutate-tip-pion-action-type-error': fieldMeta.error },
        props.className,
      )}
    >
      <option value="">- Select -</option>
      {Object.values(TIP_PION_TYPES).map((TIP_PION_TYPE) => (
        <option key={TIP_PION_TYPE} value={TIP_PION_TYPE}>
          {TIP_PION_TYPES_NAMES[TIP_PION_TYPE]}
        </option>
      ))}
    </select>
  );
};

export default MutateTipPionActionType;
